import { Component, OnInit } from '@angular/core';
import { Favorites } from '../fullmovie/favorite'
@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.css']
})
export class FavoritesComponent implements OnInit {
  datas: object[]
  loading: boolean

  constructor(public favorites: Favorites) { }

  ngOnInit() {
    this.loading = true
    setTimeout(() => {
      this.loading = false
      this.datas = this.favorites.getFavorites()
      console.log(this.datas)
    }, 700)

  }

}
